<template>
  <modal
    name="markerModal"
    adaptive
    :pivotY="0.1"
    :width="500"
    height="auto"
    classes="wf-shadow-xl wf-rounded-lg wf-bg-white wf-px-4 wf-pt-4"
    @before-open="beforeOpen"
    @closed="closed"
  >
    <div class="wf-flex wf-flex-col wf-h-full">
      <div class="wf-flex wf-items-center wf-justify-between wf-mt-2 wf-h-full">
        <div class="wf-flex-1">
          <input type="checkbox" :checked="withText" @click.prevent="updateMarkerState">
          <label for="name" class="wf-font-semibold wf-text-gray-600 wf-text-xs wf-uppercase wf-ml-2">With window information</label>
        </div>
      </div>
      <div v-if="withText" class="wf-flex wf-flex-wrap wf-items-center">
        <div class="wf-flex-1">
          <div>
            <label for="name" class="wf-font-semibold wf-text-gray-600 wf-text-xs wf-uppercase">Marker Information</label>
              <div class="wf-mt-2">
                <WysiwygEditor
                  :containerClasses="['hover:wf-bg-white', 'wf-border', 'wf-rounded', 'wf-p-4']"
                  allowNewRow
                  :value="text"
                  @input="updateMarkerText($event)"
                />
              </div>
          </div>
        </div>
      </div>
      <div v-if="withText" class="wf-flex wf-flex-wrap wf-mt-2 wf-items-center">
        <div class="wf-flex-1">
          <label for="name" class="wf-font-semibold wf-text-gray-600 wf-text-xs wf-uppercase">Display event</label>
            <select
              @change="updateMarkerActivation($event)"
              :value="activationMode"
              class="wf-mt-1 focus:wf-outline-none wf-bg-gray-200 wf-h-10 wf-text-gray-700 wf-rounded-md wf-text-sm wf-px-2 wf-w-full"
            >
              <option value="click">Click</option>
              <option value="mouseover">Hover</option>
            </select>
        </div>
      </div>
      <div class="wf-mt-4 wf-pb-4">
        <button
          class="wf-text-xs wf-w-full wf-bg-blue-300 wf-uppercase wf-w-32 wf-h-10 wf-rounded-md hover:wf-bg-blue-200 wf-text-blue-800 hover:wf-text-blue-700 wf-font-bold"
          @click.prevent="$modal.hide('markerModal')"
        >Close</button>
      </div>
    </div>
  </modal>
</template>

<script>
  import _ from 'lodash'
  import ArrayManipulation from  '../mixins/ArrayManipulation'
  import WysiwygEditor from './WysiwygEditor'

  export default {
    components: {WysiwygEditor},
    mixins: [ArrayManipulation],
    data() {
      return {
        module: null,
        element: null,
        markerId: null,
        reDrawMarkers: null
      }
    },
    computed:{
      markers() {
        return this.$store.getters[`${this.module}/content`](this.element).markers
      },
      text() {
        if (this.markerId) {
          return this.markers.find(marker => marker.id == this.markerId).textContent ?? ''
        }
        return null
      },
      withText() {
        if (this.markerId) {
          return this.markers.find(marker => marker.id == this.markerId).withText ?? false
        }
        return null
      },
      activationMode() {
        if (this.markerId) {
          return this.markers.find(marker => marker.id == this.markerId).activationMode ?? 'click'
        }
        return null
      }
    },
    methods: {
      beforeOpen(event) {
        this.module = event.params.module
        this.element = event.params.element
        this.markerId = event.params.markerId
        this.reDrawMarkers = event.params.reDrawMarkers
      },
      closed() {
        this.resetForm()
      },
      resetForm() {
        this.module = null
        this.element = null
        this.markerId = null
        this.reDrawMarkers = null
      },
      updateMarkerText: _.debounce(function (text) {
        if (this.text) {
          let newMarkers = Array.from(this.markers).map(marker => {
            if (this.markerId != marker.id) {
              return marker
            }
            return {...marker, textContent: text}
          })
          this.addToObject(this.module, {markers: newMarkers}, 'content', null, this.element)
          this.reDrawMarkers()
        }
      }, 100),
      updateMarkerState: _.debounce(function () {
        if (this.markerId) {
          let newMarkers = Array.from(this.markers).map(marker => {
            if (this.markerId != marker.id) {
              return marker
            }
            let value = !marker.withText
            return {...marker, withText: value}
          })
          this.addToObject(this.module, {markers: newMarkers}, 'content', null, this.element)
          this.reDrawMarkers()
        }
      }, 100),
      updateMarkerActivation: _.debounce(function (event) {
        if (this.markerId) {
          let newMarkers = Array.from(this.markers).map(marker => {
            if (this.markerId != marker.id) {
              return marker
            }
            return {...marker, activationMode: event.target.value}
          })
          this.addToObject(this.module, {markers: newMarkers}, 'content', null, this.element)
          this.reDrawMarkers()
        }
      }, 100)
    }
  }
</script>